import React, { useState, useRef, useEffect } from "react";
import { FaEye, FaTrash } from "react-icons/fa";
import { FaAngleLeft, FaAngleRight, FaPencil } from "react-icons/fa6";
import axios from "axios";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import { Link, useNavigate } from "react-router-dom";

import file from "../../assets/sampledata.xlsx"
import Loader from "../Loader/Loader";
import { makeKey } from "../CustomUtils";
const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selected, setSelected] = useState(new Set());
  const [bankData, setBankData] = useState(null);

  const [viewNotifications, setViewNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // 1-based for UI
  const [itemsPerPage, setItemsPerPage] = useState(10); // page size from backend (default 10)
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [state, setState] = useState([])
  const [district, setDistrict] = useState([])
  const [formData, setFormData] = useState({
    state: "",
    district: "",
    file: null
  });

  const data = async () => {
    setLoading(true)
    try {
      const token = sessionStorage.getItem("userToken");
      if (!token) {
        navigate("/login")
        return
      }
      const res = await axios.get(`${BaseUrl}/api/reg/registrationDto`, {
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {

        setState(res.data.state)
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  }

  const selectDistrict = async (e) => {
    setLoading(true)
    try {

      const res = await axios.get(`${BaseUrl}/api/reg/districts`, {
        params: { stateCode: e.target.value },
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {

        setDistrict(res.data)
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  }

  const fetchData = async (pageNumber = 1) => {
    setLoading(true)
    try {
      const token = sessionStorage.getItem("userToken")
      // Backend expects 0-based page index; UI uses 1-based, so subtract 1
      const backendPage = pageNumber - 1;

      const res = await axios.get(`${BaseUrl}/api/reg/all`, {
        params: { page: backendPage, size: itemsPerPage },
        headers: {
          'Content-Type': "application/json",
          Authorization: token,
        },

      });

      if (res) {
        const pageData = res.data?.data;

        setNotifications(pageData?.content || []);
        setViewNotifications(pageData?.content || []);
        // Use backend-provided pagination metadata
        if (typeof pageData?.totalElements === "number") {
          setTotalItems(pageData.totalElements);
        } else {
          setTotalItems(pageData?.content?.length || 0);
        }

        if (typeof pageData?.size === "number") {
          setItemsPerPage(pageData.size);
        }

        if (typeof pageData?.totalPages === "number") {
          setTotalPages(pageData.totalPages);
        } else if (pageData?.totalElements && itemsPerPage) {
          setTotalPages(Math.ceil(pageData.totalElements / itemsPerPage));
        }
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    data();

    // Load first page (UI page 1)
    fetchData(1);
  }, []);



  const handlePageChange = (pageNumber) => {
    // Guard against invalid pages
    if (pageNumber < 1 || (totalPages && pageNumber > totalPages)) return;

    setCurrentPage(pageNumber);
    // Fetch the corresponding page from backend
    fetchData(pageNumber);
  };

  const handleNextPage = () => {
    if (!totalPages || currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const [newNotification, setNewNotification] = useState({});
  const fileInputRef = useRef(null);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel"
    ];

    if (file) {


      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload an Excel file.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setFormData((prevState) => ({ ...prevState, file: file }));
    }
  };

  const handleSave = async () => {
    if (
      formData.state && formData.district &&
      formData.file
    ) {
      const token = sessionStorage.getItem("userToken");


      const store = new FormData();
      store.append("file", formData.file);
      store.append("stateCode", formData.state);
      store.append("districtCode", formData.district);

      setLoading(true);
      try {
        const res = await axios.post(
          `${BaseUrl}/api/reg/upload`,
          store,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: token,
            },
          }
        );

        if (res) {

          toast.success(res.data.message);
          fetchData()

        } else {
          toast.error(res.data.message);
        }


        setNewNotification({ title: "", file: null, location: "" });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } catch (error) {
        toast.error(error.response.data.message);
        setNewNotification({ title: "", file: null, location: "" });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please fill required fields.");
    }
  };


  const handleChange = (e) => {
    const { name, value, type } = e.target;


    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));


  };
  const handleSearch = (e) => {

    const query = e.target.value.toLowerCase();

    setSearchQuery(query);

    const filteredLinks = notifications.filter(
      (link) =>
        link.name.toLowerCase().includes(query) ||
        link.mobileNumber.toLowerCase().includes(query) ||
        link.state.toLowerCase().includes(query) ||
        link.district.toLowerCase().includes(query)
    );

    setTotalItems(filteredLinks.length);
    setTotalPages(Math.ceil(filteredLinks.length / itemsPerPage));
    setCurrentPage(1);
    setViewNotifications(filteredLinks.slice(0, itemsPerPage));


  };

  const handleCheckboxChange = (mobileNumber, programCode) => {
    const key = makeKey(mobileNumber, programCode);

    setSelected((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(key)) {
        newSelected.delete(key);
      } else {
        newSelected.add(key);
      }
      return newSelected;
    });
  };
  const initiatePayment = async () => {
    setLoading(true)
    try {
      const token = sessionStorage.getItem("userToken")
      const res = await axios.post(`${BaseUrl}/api/pay/initiateBulk`, Array.from(selected), {

        headers: {
          'Content-Type': "application/json",
          Authorization: token,
        },

      });

      if (res) {
        toast.success("Redirecting you to payment screen...");
        setBankData(res.data);
        setTimeout(() => {
          document.forms["payuForm"].submit();
        }, 500);
      }


    } catch (error) {
      toast.error(error.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="home-dashboard">
          <div className="ticket-tab">

            <h3 className="text-center text-uppercase text-success" style={{ fontWeight: "500" }}>
              Bulk<span style={{ color: "#20e61b" }}> Register</span>
            </h3>

            <hr style={{ color: "#ffc107" }} />

            <div className="row mb-3">
              <p>To register students in bulk, kindly download the given format, fill all the columns of Excel properly and then upload the same excel below,</p>

              <div className="text-center">

                <Link className="" target="_blank" to={file} download="Bulk_Format.xlsx" rel="noopener noreferrer"> Download Format </Link>
              </div>



              <div className="col-md-6 form-group my-3">
                <label className="mb-2">State:<span style={{ color: "red" }}>*</span></label>
                <select className="form-control" name="state" value={formData.state} onChange={(e) => { handleChange(e); selectDistrict(e) }}>
                  <option value={""}>Select State...</option>
                  {state?.map((item, index) => (
                    <option key={index} value={item.code} >{item.name}</option>

                  ))}

                </select>

              </div>
              <div className="col-md-6 form-group my-3">
                <label className="mb-2">District:<span style={{ color: "red" }}>*</span></label>
                <select className="form-control" name="district" value={formData.district} onChange={handleChange}>
                  <option value={""}>Select District...</option>
                  {district?.map((item, index) => (
                    <option key={index} value={item.code} >{item.name}</option>

                  ))}
                </select>

              </div>
              <div className="col-md-6 mt-2">
                <label className="form-label">Upload File:<span style={{ color: "red", fontSize: "1rem" }}>*</span></label>
                <input
                  type="file"
                  className="form-control"
                  name="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-2 mt-3">
                <button
                  type="button"
                  className="btn btn-success mt-4"
                  onClick={handleSave}
                >
                  Upload
                </button>
              </div>

            </div>
          </div>
          <div className="ticket-tab">
            {/* <hr
              style={{
                height: "2px",
                backgroundColor: "green",
                margin: "4% 0",
              }}
            /> */}
            <div className="row mb-4">
              <div className="col-6">
                <h3 className=" text-uppercase text-success" style={{ fontWeight: "500" }}>
                  Manage<span style={{ color: "#20e61b" }}> Students</span>
                </h3>

              </div>

              {/* <div className="col-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name, district, state..."
                  value={searchQuery}
                  onChange={handleSearch}
                />

              </div> */}
            </div>
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th >Name</th>
                  <th>State</th>
                  <th>District</th>
                  <th>Mobile Number</th>
                  <th >Status</th>
                </tr>
              </thead>
              <tbody>
                {viewNotifications.length > 0 ? (
                  viewNotifications
                    .filter((notification) => notification.feeStatus === false)
                    .map((notification, index) => {
                      const rowKey = `${notification.name}-${notification.mobileNumber}-${index}`;
                      const selectKey = makeKey(notification.mobileNumber, notification.programCode);

                      return (
                        <tr key={rowKey}>
                          <td>{notification.firstName} {notification.lastName}</td>
                          <td>{notification.state}</td>
                          <td>{notification.district}</td>
                          <td>{notification.mobileNumber}</td>
                          <td>
                            <input
                              type="checkbox"
                              name="status"
                              onChange={() => handleCheckboxChange(notification.mobileNumber, notification.programCode)}
                              checked={selected.has(selectKey)}
                            />
                          </td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      No User Found
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
            {selected.size > 0 && (
              <div className="text-end">
                <button className="btn btn-success" name="payment" onClick={() => initiatePayment()}>
                  Proceed To Pay
                </button>
              </div>)}

            <div className="row mt-4">
              <div className="col-5">
                {(() => {
                  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
                  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
                  return (
                    <span>
                      Showing {startItem}-{endItem} of {totalItems}
                    </span>
                  );
                })()}
              </div>
              <div className="col-7 ">
                <div className="d-flex align-items-center">
                  {/* Previous Button */}
                  <button
                    style={{ width: "8%", borderRadius: "50%" }}
                    className="btn btn-success"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    <FaAngleLeft />
                  </button>

                  {/* Page Numbers */}
                  <div className="mx-3 d-flex">
                    {Array.from({ length: Math.ceil(totalItems / itemsPerPage) }).map((_, index) => {
                      const pageNum = index + 1; // Start from 1

                      // Show only the previous, current, and next page
                      if (pageNum === currentPage || pageNum === currentPage - 1 || pageNum === currentPage + 1) {
                        return (
                          <button
                            key={pageNum}
                            className={`btn mx-1 ${currentPage === pageNum ? "active btn-primary" : "btn-light"}`}
                            onClick={() => handlePageChange(pageNum)}
                          >
                            {pageNum}
                          </button>
                        );
                      }
                      return null;
                    })}
                  </div>

                  {/* Next Button */}
                  <button
                    style={{ width: "8%", borderRadius: "50%" }}
                    className="btn btn-success"
                    onClick={handleNextPage}
                    disabled={currentPage >= Math.ceil(totalItems / itemsPerPage)}
                  >
                    <FaAngleRight />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {bankData && (
            <form
              name="payuForm"
              action={bankData?.action}
              method="post"
              style={{ display: "none" }}
            >
              {Object.entries(bankData).map(
                ([key, value]) =>
                  key !== "action" && (
                    <input key={key} type="hidden" name={key} value={value} />
                  )
              )}
            </form>
          )}
        </div>
      )}
    </>
  );
};

export default Notifications;
